import { cn } from "@/lib/utils";
import { text } from "@/constants/tailwind-theme";
import ReactGA from "react-ga";

const PortfolioItemComponent = ({
  title,
  url,
  image,
  selectedTag,
  tags = [],
}) => {
  if (!tags.includes(selectedTag)) {
    return null;
  }

  return (
    <div
      style={{ backgroundImage: `url(${image})`, backgroundSize: "cover" }}
      className="group flex aspect-square w-60 items-center justify-center overflow-hidden rounded-lg border-2 border-primary-500"
    >
      <div className="flex h-full w-full flex-col items-center justify-center bg-primary-500 opacity-0 transition duration-300 group-hover:opacity-90">
        <h2 className={cn(text.heading2, "mb-3 text-center text-white")}>
          {title}
        </h2>
        <a
          onClick={() => {
            ReactGA.event({ category: "OUR_WORK", action: title });
          }}
          target="_blank"
          rel="noopener noreferrer"
          href={url}
          className={cn(text.heading3, "text-white hover:underline")}
        >
          See Project
        </a>
      </div>
    </div>
  );
};

export default PortfolioItemComponent;
